// 
export enum DocumentManageKinds {
  Normal = 1, // 直接記載
  Reception = 2, // 診断書WF
  // and more..
}
